import { render, staticRenderFns } from "./HerisOrdenesEdit.vue?vue&type=template&id=5785f6dc&"
import script from "./HerisOrdenesEdit.vue?vue&type=script&lang=js&"
export * from "./HerisOrdenesEdit.vue?vue&type=script&lang=js&"
import style0 from "./HerisOrdenesEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports